module.exports = __webpack_public_path__ + "img/avatar3.6bca3b80.png";